import React, { startTransition } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import configuration from '../../../utils/configuration';
import { useMediaQuery } from '@mui/material';
import { getSiteName } from '../../../utils/brandingConfig';

const FooterBootom = (props) => {
  const navigate = useNavigate()
  const isMobile = useMediaQuery('(max-width: 48rem)');
  const siteName = getSiteName();

  // Handler to wrap navigation in startTransition for lazy-loaded routes
  const handleNavigation = (e, path) => {
    e.preventDefault();
    startTransition(() => {
      navigate(path);
    });
  };

    return(
        <>
         <div className={`footer-bottom ${props.errorPage ? 'bg-none border-none' : ``} footer_new_bottom1 pt-3 pb-3`}>
          <div className="container">
            <div className="row">
              <div className="col-md-5 col-12">
                <div className="left_data_footer">
                  <ul className="stripfot pl-0">
                    {!isMobile ? (
                      <li>{configuration.get('configData.copyright_content')}</li>
                    ) : null}                 
                    <li>
                      <Link aria-label='Navigate to Help' onClick={(e) => handleNavigation(e, "/help-and-support")}>Help</Link>
                    </li>
                    <li>
                      <Link aria-label='Navigate to About' onClick={(e) => handleNavigation(e, "/about")}>About</Link>
                    </li>
                    <li>
                      <Link aria-label='Navigate to Contact' onClick={(e) => handleNavigation(e, "/contact-us")}>Contact</Link>
                    </li>
                  </ul>
                  <ul className="socialnewfot">
                    <li>
                      <a target={"_blank"} href={configuration.get('configData.twitter_link')} aria-label={`Follow ${siteName} on Twitter`}>
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a target={"_blank"} href={configuration.get('configData.instagram_link')} aria-label={`Follow ${siteName} on Instagram`}>
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-7 col-12">
                <div className="right_data_footer pull-right">
                  <ul className="pl-0">
                    <li>
                      <Link 
                        aria-label='Navigate to How It Works' 
                        onClick={(e) => handleNavigation(e, "/how-it-works")}
                      >
                        How It Works
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Referral' 
                        onClick={(e) => handleNavigation(e, "/referral")}
                      >
                        Referral
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Billing Support'
                        onClick={(e) => handleNavigation(e, "/support/billing")}
                      >
                        Billing Support
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to USC Terms Of Services' 
                        onClick={(e) => handleNavigation(e, "/terms-of-Services")}
                      >
                        Terms Of Services
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Privacy Policy' 
                        onClick={(e) => handleNavigation(e, "/privacy-policy")}
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to USC 2257' 
                        onClick={(e) => handleNavigation(e, "/USC-2257")}
                      >
                        USC 2257
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Cancellation Policy' 
                        onClick={(e) => handleNavigation(e, "/cancellation-policy")}
                      >
                        Cancellation Policy
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Refund Policy' 
                        onClick={(e) => handleNavigation(e, "/refund-policy")}
                      >
                        Refund Policy
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Content Moderation Policy' 
                        onClick={(e) => handleNavigation(e, "/content-moderation-policy")}
                      >
                        Content Moderation Policy
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Content Removal Policy'
                        onClick={(e) => handleNavigation(e, "/content-removal-policy")}
                      >
                        Content Removal Policy
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Performer Agreement Policy' 
                        onClick={(e) => handleNavigation(e, "/performer-agreement")}
                      >
                        Performer Agreement Policy
                      </Link>
                    </li>
                    <li>
                      <Link 
                        aria-label='Navigate to Complaint Policy' 
                        onClick={(e) => handleNavigation(e, "/complaint-policy")}
                      >
                        Complaint Policy
                      </Link>
                    </li>
                  </ul>
                  {isMobile ? (
                    <ul className='pl-0'>
                      <li>{configuration.get('configData.copyright_content')}</li>
                    </ul>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        </>
    )
}

export default FooterBootom
